"use client";

import * as React from "react";
import CssBaseline from "@mui/material/CssBaseline";
import { ThemeProvider } from "@mui/material/styles";

import { appConfig } from "@/config/app";
import { createTheme } from "@/styles/theme/create-theme";

function CustomThemeProvider({ children, locale }) {

	const primaryColor = appConfig.primaryColor;

	const theme = createTheme({ primaryColor });

	return (
		<ThemeProvider disableTransitionOnChange theme={theme} defaultMode={appConfig.theme}>
			<CssBaseline />
			{children}
		</ThemeProvider>
	);
}

export { CustomThemeProvider as ThemeProvider };
